var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Text, TouchableOpacity, View, } from 'react-native';
import { useDebounceFn } from '../../hooks/useDebounceFn';
import { useStyle } from '../../hooks/useStyle';
export function Box(props) {
    const _a = props || {}, { bs, style, onPress, wait = 0, withoutBox = false } = _a, rest = __rest(_a, ["bs", "style", "onPress", "wait", "withoutBox"]);
    const styles = useStyle({
        bs: bs || {},
    });
    const { run: deboundPress } = useDebounceFn((e) => {
        onPress === null || onPress === void 0 ? void 0 : onPress(e);
    }, {
        wait,
        leading: true,
        trailing: false,
    });
    const isChildStr = typeof props.children === 'string' ||
        typeof props.children === 'number';
    const content = isChildStr ? (React.createElement(Text, Object.assign({}, rest, { style: [styles.bs || {}, style] }), props.children)) : !withoutBox ? (React.createElement(View, Object.assign({}, rest, { style: [styles.bs || {}, style] }), props.children)) : (React.createElement(React.Fragment, null, props.children));
    if (typeof props.onPress === 'function') {
        return (React.createElement(TouchableOpacity, Object.assign({ activeOpacity: 0.6, style: [withoutBox ? style : {}] }, rest, { onPress: deboundPress }), content));
    }
    return content;
}
export default Box;
